var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.848,
    height: 12.848,
    viewBox: "0 0 12.848 12.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.424,0A6.424,6.424,0,1,1,0,6.424,6.424,6.424,0,0,1,6.424,0ZM4.459,3.892l-.033-.029a.4.4,0,0,0-.5,0l-.033.029-.029.033a.4.4,0,0,0,0,.5l.029.033L5.856,6.424,3.892,8.388l-.029.033a.4.4,0,0,0,0,.5l.029.033.033.029a.4.4,0,0,0,.5,0l.033-.029L6.424,6.991,8.388,8.956l.033.029a.4.4,0,0,0,.5,0l.033-.029.029-.033a.4.4,0,0,0,0-.5l-.029-.033L6.991,6.424,8.956,4.459l.029-.033a.4.4,0,0,0,0-.5l-.029-.033-.033-.029a.4.4,0,0,0-.5,0l-.033.029L6.424,5.856,4.459,3.892l-.033-.029Z",
    fill: "#1447d4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossLogo);
export default __webpack_public_path__ + "static/media/crossLogo.ecf83676.svg";
export { ForwardRef as ReactComponent };